import * as React from 'react';
import { styled } from '@fluentui/react';
import { GroupedComboBoxBase } from './GroupedComboBox.base';
import { getStyles } from './GroupedComboBox.styles';
import {
    IGroupedComboBoxProps,
    IGroupedComboBoxStyleProps,
    IGroupedComboBoxStyles,
} from './GroupedComboBox.types';

export type IGroupedComboBoxPropsWithRef = React.PropsWithoutRef<IGroupedComboBoxProps> &
    React.RefAttributes<HTMLDivElement>;

/**
 * A combo box with collapsible sections
 */
export const GroupedComboBox: React.FunctionComponent<IGroupedComboBoxPropsWithRef> = styled<
    IGroupedComboBoxPropsWithRef,
    IGroupedComboBoxStyleProps,
    IGroupedComboBoxStyles
>(GroupedComboBoxBase, getStyles, undefined, { scope: 'GroupedComboBox' });

GroupedComboBox.displayName = 'GroupedComboBox';
